import { ApiObject, RudderAnalytics } from '@rudderstack/analytics-js'
import { getDeviceType } from '../utils/getDeviceType'

const rudderAnalytics = new RudderAnalytics()

if (window.rudderanalytics && import.meta.env.PROD) {
  rudderAnalytics.load(
    import.meta.env.PUBLIC_LIVECHAT_RUDDERSTACK_WRITE_KEY,
    import.meta.env.PUBLIC_LIVECHAT_RUDDERSTACK_DATA_PLANE_URL,
    {},
  )
}

const trackEvent = (eventName: string, properties?: ApiObject | null | undefined) => {
  if (window.rudderanalytics && import.meta.env.PROD) {
    const finalProperties = { ...properties, device_type: getDeviceType() }
    rudderAnalytics.track(eventName, finalProperties, () => {
      console.debug(`Track event "${eventName}" successfully submitted to RudderStack SDK.`, finalProperties)
    })
  }
}

export { rudderAnalytics, trackEvent }
